export const isMobileDevice = () => {
  return window.matchMedia(
    'only screen and (min-width: 200px) and (max-width: 639px)'
  ).matches;
};

export const isMobileTabDevice = () => {
  return window.matchMedia(
    'only screen and (min-width: 200px) and (max-width: 1024px)'
  ).matches;
};

export const isAndroid = () => {
  let ReactNativeWebView = (window as any).ReactNativeWebView;
  return ReactNativeWebView ? true : false;
};
